import { render, staticRenderFns } from "./ExpandableInput.vue?vue&type=template&id=e08c0ea6"
import script from "./ExpandableInput.vue?vue&type=script&lang=ts"
export * from "./ExpandableInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports